/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_macro_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What calorie number do I enter?`)
};

const es_macro_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Qué número de calorías introduzco?`)
};

const de_macro_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Welchen Kalorienwert gebe ich ein?`)
};

const nl_macro_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Welk caloriegetal vul ik in?`)
};

const fr_macro_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quel nombre de calories dois-je saisir ?`)
};

const it_macro_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quale numero di calorie devo inserire?`)
};

const pt_br2_macro_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qual valor de calorias eu devo informar?`)
};

const pt_macro_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Que valor calórico devo introduzir?`)
};

const ja_macro_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`どのカロリー数値を入力すればいいですか?`)
};

const zh_macro_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`我该输入什么热量数值？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const macro_faq_q4 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.macro_faq_q4(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("macro_faq_q4", locale)
	if (locale === "en") return en_macro_faq_q4(inputs)
	if (locale === "es") return es_macro_faq_q4(inputs)
	if (locale === "de") return de_macro_faq_q4(inputs)
	if (locale === "nl") return nl_macro_faq_q4(inputs)
	if (locale === "fr") return fr_macro_faq_q4(inputs)
	if (locale === "it") return it_macro_faq_q4(inputs)
	if (locale === "pt-BR") return pt_br2_macro_faq_q4(inputs)
	if (locale === "pt") return pt_macro_faq_q4(inputs)
	if (locale === "ja") return ja_macro_faq_q4(inputs)
	return zh_macro_faq_q4(inputs)
};